import { useState } from "react";
import { reviews } from "../../../mocks/home";

export default function SocialProof() {
  const [showAll, setShowAll] = useState(false);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
            Sosyal Kanıt
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            İNSANLAR TADINI
            <br />
            “ANNE ELİ” DİYE ANLATIYOR.
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            Sıcak, doyurucu ve ev yemeği hissi veren bir öğün deneyimi.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review, i) => (
            <figure
              key={i}
              className="bg-background-50 border border-background-200 rounded-lg p-7 flex flex-col"
            >
              <div className="flex gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, s) => (
                  <i key={s} className="ri-star-fill text-lg"></i>
                ))}
              </div>
              <blockquote className="mt-4 text-foreground-800 leading-relaxed flex-1">
                “{review.quote}”
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className="ri-user-3-line"></i>
                </div>
                <span className="text-sm font-semibold text-foreground-600">
                  {review.source}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => setShowAll(true)}
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md border-2 border-foreground-200 text-foreground-800 text-base font-bold hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            TÜM YORUMLARI GÖR
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      {/* Modal for all reviews */}
      {showAll && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setShowAll(false)}
          ></div>
          <div className="relative bg-background-50 rounded-lg max-w-lg w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 animate-fade-up">
            <button
              onClick={() => setShowAll(false)}
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-background-100 text-foreground-700 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="Kapat"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
            <h3 className="font-heading text-2xl font-bold text-foreground-950">
              Müşteri Yorumları
            </h3>
            <p className="mt-2 text-xs text-foreground-500">
              Gerçek müşteri yorumları — kaynak: Google Yorumları
            </p>
            <div className="mt-5 space-y-4">
              {reviews.map((review, i) => (
                <div
                  key={i}
                  className="border border-background-200 rounded-lg p-5"
                >
                  <div className="flex gap-0.5 text-accent-500">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <i key={s} className="ri-star-fill"></i>
                    ))}
                  </div>
                  <p className="mt-3 text-foreground-800 leading-relaxed">
                    “{review.quote}”
                  </p>
                  <span className="mt-3 block text-sm font-semibold text-foreground-500">
                    {review.source}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}